import { REGISTRATION_STATUS, PROCESSED_STATUS } from '../constants';

export const handleRegStatus = (status, isMissingAnyDocument) => {
  const { 
    WITHIN_7DMBG,
    AWAITING_PAYMENT_CONFIRMATION,
    PACKET_MISSING,
    TITLE_MISSING,
    PACKET_AND_TITLE_MISSING,
    TITLE_NOT_RECIEVED,
    PACKET_AND_TITLE_NOT_RECEIVED,
    PACKET_NOT_RECEIVED,
    PARTIAL_RECEIVED,
    REJECTED_RECEIVED,
    READY_TO_WORK,
    READY_TO_SUBMIT,
    DELAYED,
    SUBMITTED,
    SUBMITTED_TITLE_ONLY,
    DELAYED_RESOLVED,
    REJECTED_RESOLVED,
    REJECTED,
    COMPLETED,
    CLOSED_BACKED_OUT,
    CLOSED_ROLLED_BACK,
    TOTAL_LOSS,
    PENDING_EXCHANGE,
  } = REGISTRATION_STATUS;

  switch (status) {
    case WITHIN_7DMBG:
    case AWAITING_PAYMENT_CONFIRMATION:
    case PACKET_MISSING:
    case TITLE_MISSING:
    case PACKET_AND_TITLE_MISSING:
    case TITLE_NOT_RECIEVED:
    case PACKET_NOT_RECEIVED:
    case PACKET_AND_TITLE_NOT_RECEIVED:
      return PROCESSED_STATUS.PENDING;
    case PARTIAL_RECEIVED:
    case REJECTED_RECEIVED:
    case READY_TO_WORK:
    case READY_TO_SUBMIT:
      return PROCESSED_STATUS.PAPERWORK_RECEIVED;
    case DELAYED:
      return isMissingAnyDocument ?
        PROCESSED_STATUS.ACTION_REQUIRED :
        PROCESSED_STATUS.PAPERWORK_RECEIVED;
    case SUBMITTED:
    case SUBMITTED_TITLE_ONLY:
      return PROCESSED_STATUS.SUBMITTED_FOR_PROCESSING;
    case DELAYED_RESOLVED:
    case REJECTED_RESOLVED:
      return PROCESSED_STATUS.SUBMITTED_FOR_PROCESSING;
    case REJECTED:
      return isMissingAnyDocument ?
        PROCESSED_STATUS.ACTION_REQUIRED :
        PROCESSED_STATUS.SUBMITTED_FOR_PROCESSING;
    case COMPLETED:
      return PROCESSED_STATUS.COMPLETED;
    case CLOSED_ROLLED_BACK:
    case CLOSED_BACKED_OUT:
      return PROCESSED_STATUS.NOT_FOUND;
    case TOTAL_LOSS:
      return PROCESSED_STATUS.TOTAL_LOSS;
    case PENDING_EXCHANGE:
      return PROCESSED_STATUS.PAUSED;
    default:
      return PROCESSED_STATUS.NOT_STARTED;
  }
}